var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6748 0.881652C22.9427 1.14114 23.0931 1.47658 23.1248 1.82135C23.1331 1.91204 23.1333 2.00376 23.1249 2.09537C23.1135 2.22184 23.086 2.34718 23.0424 2.46814L16.3107 22.5177C16.1125 23.108 15.5702 23.5145 14.948 23.5391C14.3258 23.5637 13.7531 23.2014 13.5089 22.6286L9.88224 14.1224L1.73663 10.3485C1.18573 10.0933 0.84302 9.53109 0.868519 8.92447C0.894017 8.31784 1.28269 7.78642 1.85307 7.57832L21.0861 0.561144C21.1995 0.517029 21.3172 0.487177 21.4365 0.471646C21.5279 0.459677 21.6198 0.456252 21.7109 0.461124C22.0521 0.479158 22.3888 0.61322 22.6569 0.864641C22.6629 0.870256 22.6688 0.875926 22.6748 0.881652ZM16.0767 5.58225L6.29145 9.15241L10.6948 11.1925L16.0767 5.58225ZM12.8044 13.327L18.0775 7.83013L14.7219 17.8244L12.8044 13.327Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.ee61ff927a54e9e0f2f191778aca62ad.svg";
export { ForwardRef as ReactComponent };